import React, { useMemo, useEffect, useState } from "react";
import Card from "components/card";
import axios from "../../../../api/axios";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { TailSpin } from "react-loader-spinner";
import PoliceReportDetailsModal from "./policeReportDetails";
//import PoliceNotifications from "./PoliceNotifications";

const PoliceCheckTable = (props) => {
  const { columnsData, tableData } = props;
  const [showModal, setShowModal] = React.useState(false);
  const data = useMemo(() => tableData, [tableData]);
  const [selectedReport, setSelectedReport] = React.useState(null);
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = useState(true);
  const [searchName, setSearchName] = useState("");
  const [searchDate, setSearchDate] = useState("");

  const fetchReportDetails = async (reportId) => {
    const storedToken = localStorage.getItem("token");
    const token = "Bearer " + storedToken.replace(/"/g, "");
    const headers = {
      Authorization: token,
      "Content-Type": "application/json",
    };

    try {
      const response = await axios.get(`/api/reports/report/${reportId}`, {
        headers,
      });
      //console.log("tedhenat", response.data);
      setSelectedReport(response.data);
      setShowModal(true);
    } catch (error) {}
  };

  const handleSearch = async () => {
    const storedToken = localStorage.getItem("token");
    const token = "Bearer " + storedToken.replace(/"/g, "");
    const headers = {
      Authorization: token,
      "Content-Type": "application/json",
    };

    try {
      const response = await axios.get("/api/reports/filterApprovedAdmin", {
        headers,
        params: {
          reportName: searchName,
          reportDate: searchDate,
        },
      });
      setRows(response.data.reverse());
    } catch (error) {
      console.error("Error filtering reports", error);
    }
  };

  const customLocaleText = {
    noRowsLabel: "Nuk ka raporte në proces",
    footerRowSelected: (count) =>
      `${count === 1 ? "1 rresht" : `${count} rreshta`} i selektuar`,
  };
  const columns = [
    {
      field: "reportName",
      headerName: <b>Nr i Raportit</b>,
      flex: 1,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
      editable: false,
    },
    {
      field: "date",
      headerName: <b>Data e raportimit</b>,
      flex: 1,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
      editable: false,
      valueFormatter: ({ value }) => {
        return new Date(value).toLocaleString("en-US", {
          dateStyle: "short",
          timeStyle: "short",
        });
      },
    },
    {
      field: "reviewedByAdministrator",
      headerName: <b>Data e shqyrtimit nga admini</b>,
      flex: 1,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
      valueFormatter: ({ value }) =>
        value
          ? new Date(value).toLocaleString("en-US", {
              dateStyle: "short",
              timeStyle: "short",
            })
          : "-",
    },
    {
      field: "category",
      headerName: <b>Kategoria</b>,
      flex: 1,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
      editable: false,
    },
    // {
    //   field: "email",
    //   headerName: <b>Email adresa</b>,
    //   flex: 1,
    //   minWidth: 180,
    //   align: "center",
    //   headerAlign: "center",
    //   editable: false,
    // },
    {
      field: "detajet",
      headerName: <b>Shiko detajet</b>,
      id: "mymodal",
      flex: 0.7,
      minWidth: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <label
          id="mymodal"
          htmlFor="my-modal-5"
          className="rounded-xl bg-brand-500 px-[15px] py-[8px] text-base font-medium text-white transition duration-200 hover:bg-brand-700 active:bg-brand-800 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          onClick={() => fetchReportDetails(params.row.id)}
        >
          Detajet
        </label>
      ),
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const storedToken = localStorage.getItem("token");

      let token = "Bearer " + storedToken.replace(/"/g, "");
      const headers = {
        Authorization: token,
        "Content-Type": "application/json",
      };
      try {
        const response = await axios.get("/api/reports/approvedMrepo", {
          headers,
        });
        setRows(response.data.reverse());
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const gridLocalization = {
    props: {
      MuiGrid: {
        footerRowSelected: "rresht i selektuar",
      },
    },
  };

  return (
    <>
      {loading ? (
        <div className="mt-11 flex items-center justify-center pt-11">
          <TailSpin bg-brand-500 height={70} width={70} />
        </div>
      ) : (
        <>
          <div className="mb-4 flex flex-wrap gap-4">
            <input
              type="text"
              placeholder="Kërko sipas emrit të raportit"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              className="w-full rounded border border-gray-300 px-3 py-2 sm:w-[250px]"
            />
            <input
              type="date"
              value={searchDate}
              onChange={(e) => setSearchDate(e.target.value)}
              className="w-full rounded border border-gray-300 px-3 py-2 sm:w-[200px]"
            />
            <button
              onClick={handleSearch}
              className="rounded bg-brand-500 px-4 py-2 text-white hover:bg-brand-700"
            >
              Kërko
            </button>
          </div>

          <Card extra={"w-full sm:overflow-auto p-4"}>
            <header className="relative flex items-center justify-between">
              <div className="pb-2 text-xl font-bold text-black  dark:text-white">
                Lista e raporteve të aprovuara nga OmniRep
              </div>
              {/* modali per raportin ne detaje */}
              <PoliceReportDetailsModal 
                          selectedReport={selectedReport}
                          adminName={localStorage.getItem("name")} />
                 {/* <ReportDetailsModal
                            selectedReport={selectedReport}
                            adminName={localStorage.getItem("adminName")}
                          /> */}
            </header>
            <Box>
              <DataGrid
                rows={rows}
                columns={columns}
                className="text-black dark:text-white"
                autoHeight
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                pageSizeOptions={[10]}
                disableSelectionOnClick={true}
                disableColumnMenu
                localeText={customLocaleText}
              />
            </Box>
          </Card>
        </>
      )}
    </>
  );
};

export default PoliceCheckTable;
